import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import {
  UploadFile,
  UploadInput,
  UploaderOptions,
  UploadOutput
} from 'ngx-uploader';
import { CustomizeHomePageService } from './../../customize-homepage.service';
import { CustomizeHomePage } from './../../models/customize-homepage';
import { BaseServices } from './../../../kuba.services';
import { ToasterComponent } from 'src/app/_directives/toaster.component';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { Roles } from 'src/app/_models';

@Component({
  selector: 'customize-page',
  templateUrl: 'customize-homepage-tab.component.html'
})
export class CustomizeHomePageCreationComponent implements OnInit {
  //#region variable

  @ViewChild(ToasterComponent, { static: false })
  toasterComponent: ToasterComponent;
  text: string;
  HomepageForm: FormGroup;
  applicationId: number;
  customId: number;
  customizeHomepage = new CustomizeHomePage();
  Id: number;
  isFileChoosed = false;
  files: UploadFile[] = [];
  uploadInput: EventEmitter<UploadInput>;
  humanizeBytes: Function;
  dragOver: boolean;
  option: UploaderOptions;
  logo: any;
  fileName: string;
  isAdmin: boolean;
  portalLogo: boolean;
  toggleTextEditorTab: boolean;
  public selectedFiles;
  uploadStart: boolean;
  applicationName: string;
  isShowSubFeatures: boolean;
  logoclass: string;

  private subscriptions: Subscription[] = [];
  //#endregion

  //#region constructor

  /**
   * constructor
   * @param formBuilder {FormBuilder}
   * @param customizeHomePageService {CustomizeHomePageService}
   */
  constructor(
    private formBuilder: FormBuilder,
    private customizeHomePageService: CustomizeHomePageService,
    private http: HttpClient,
    public route: ActivatedRoute,
    private location: Location
  ) {
    this.uploadInput = new EventEmitter<UploadInput>();
    this.HomepageForm = this.formBuilder.group({
      ContentData: ['']
    });
  }
  //#endregion

  //#region page-events
  /**
   * init
   */
  ngOnInit() {
    document.querySelector('body').classList.remove('opened');
    this.applicationName = BaseServices.ApplicationName;
    this.applicationId = BaseServices.ApplicationId;
    if (this.applicationId == 5) {
      this.isShowSubFeatures = false;
    } else {
      this.isShowSubFeatures = true;
    }
    this.isAdmin = +BaseServices.roleId === Roles.ADMIN ? true : false;
    if (+BaseServices.roleId === Roles.PORTAL) {
      this.changeNavigation(56);
      this.logoclass = 'active';
    } else {
      this.changeNavigation(45);
    }
  }
  //#endregion

  //#region control-events

  /**
   * save home page
   */
  saveData() {
    this.customizeHomepage.Id = this.Id ? this.Id : 0;
    this.customizeHomepage.AppId = this.applicationId;
    this.customizeHomepage.BusinessId = BaseServices.BusinessId;
    if (this.portalLogo) {
      this.customizeHomepage.Title = this.fileName;
      this.customizeHomepage.ContentData = this.logo;
    } else {
      this.customizeHomepage.ContentData = this.HomepageForm.value.ContentData;
    }
    this.customizeHomepage.CmsId = this.customId;
    this.customizeHomepage.Status = '1';
    this.customizeHomepage.CreatedBy = BaseServices.UserId;
    if (this.Id > 0) {
      this.subscriptions.push(
        this.customizeHomePageService
          .update(this.customizeHomepage)
          .subscribe((isCustomzationUpdated: any) => {
            if (isCustomzationUpdated) {
              this.toasterComponent.callToast();
            }
          })
      );
    } else {
      this.subscriptions.push(
        this.customizeHomePageService
          .add(this.customizeHomepage)
          .subscribe((isCustomzationAdded: any) => {
            if (isCustomzationAdded) {
              this.toasterComponent.callToast();
            }
          })
      );
    }
  }

  back() {
    this.location.back();
  }
  /**
   * tab change event
   * @param cmsId {number}
   */
  changeNavigation(cmsId: number) {
    if (cmsId === 54 || cmsId === 56 || cmsId === 58) {
      if (cmsId === 54 || cmsId === 58) {
        this.toggleTextEditorTab = false;
        this.portalLogo = false;
      } else if (cmsId === 56) {
        this.toggleTextEditorTab = false;
        this.portalLogo = true;
      } else {
        this.toggleTextEditorTab = true;
        this.portalLogo = true;
      }
    } else {
      this.toggleTextEditorTab = true;
      this.portalLogo = false;
      this.logo = null;
      this.logoclass = 'inactive';
    }
    this.customId = cmsId;
    this.subscriptions.push(
      this.customizeHomePageService
        .getData(this.applicationId, this.customId, BaseServices.UserId)
        .subscribe((homePageData: any) => {
          this.Id = homePageData.Id;
          if (this.portalLogo) {
            this.logo = homePageData.ContentData;
          }
          if (homePageData) {
            let homePage = {
              ContentData: homePageData.ContentData
                ? homePageData.ContentData
                : ''
            };
            (<FormGroup>this.HomepageForm).setValue(homePage, {
              onlySelf: true
            });
          } else {
            let homePage = {
              ContentData: ''
            };
            (<FormGroup>this.HomepageForm).setValue(homePage, {
              onlySelf: true
            });
          }
        })
    );
  }

  /**
   * on upload event
   * @param output
   */
  onUploadOutput(output: UploadOutput): void {
    if (output.type === 'allAddedToQueue') {
    } else if (
      output.type === 'addedToQueue' &&
      typeof output.file !== 'undefined'
    ) {
      this.isFileChoosed = true;
      this.files.push(output.file);
    } else if (
      output.type === 'uploading' &&
      typeof output.file !== 'undefined'
    ) {
      const index = this.files.findIndex(
        file => typeof output.file !== 'undefined' && file.id === output.file.id
      );
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      this.files = this.files.filter(
        (file: UploadFile) => file !== output.file
      );
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
      this.dragOver = false;
    } else if (output.type === 'drop') {
      this.dragOver = false;
    } else if (output.type === 'done') {
      if (output.file.response) {
        if (this.portalLogo) {
          this.logo = output.file.response.Result.path;
          this.fileName = output.file.name;
        } else {
          this.fileName = output.file.response.originalname;
        }
      }
    } else if (
      output.type === 'rejected' &&
      typeof output.file !== 'undefined'
    ) {
    }
  }

  /**
   * Method to upload portal logo
   * @param selectedFiles Array of selected files, only first file will be uploaded
   */
  filesSelect(selectedFiles: any): void {
    this.uploadStart = true;
    this.selectedFiles = Array.from(selectedFiles.currentTarget.files).map(
      file => file
    );
    let formData = new FormData();
    formData.append('file', this.selectedFiles[0]);

    this.subscriptions.push(
      this.http
        .post(
          environment.BASE_URL +
            '/file/upload/portal/logo/' +
            BaseServices.PortalId,
          formData
        )
        .map((response: any) => {
          this.uploadStart = false;
          let res = response;
          this.logo = res.path;
        })
        .subscribe(
          result => {},
          error => console.log('Upload article Sign Error : ', error),
          () => console.log('Upload article  Sign Complete')
        )
    );
  }

  clear() {
    this.Id = 0;
    let homePage = {
      ContentData: ''
    };
    this.logo = null;
    (<FormGroup>this.HomepageForm).setValue(homePage, { onlySelf: true });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
  //#endregion
}
